export enum TooltipSourceType {
    TOOLTIP_PROPERTY = 0,
    VALIDATION_WARNING = 1,
    DISABLED_TOOLTIP_PROPERTY = 2,
    DYNAMIC = 3,
    DYNAMIC_DESIGNER = 4,
    QUICK_INFO = 5,
    CURRENCY_EXCHANGE_INFO = 6 // The dynamically-added multi-currency exchange rate information
}
